import { makeStyles } from '@mui/styles';

const COARSE_POINTER = '@media (hover: none) and (pointer: coarse)';

export const useStyles = makeStyles((theme: any) => ({
  container: {
    display: "flex", gap: "10px", marginTop: "10px"
  },
  containerStacked: {
    flexDirection: 'column',
  },
  disbursementsContainer: {
    flex: 2,
    maxWidth: "calc(80% - 10px)",
    border: "solid 1px #cfd8dc",
    '& td, th': {
      borderBottom: "1px solid #cfd8dc"
    },
    '& th:first-of-type, & tr td:first-child': {
      paddingLeft: "36px"
    },
  },
  // The cards carry their own surface, so the list wrapper drops its chrome and fills the row.
  disbursementsContainerStacked: {
    flex: 'none',
    minWidth: 0,
    maxWidth: 'none',
    border: 'none',
    boxShadow: 'none',
    backgroundColor: 'transparent',
  },
  balancingContainer: {
    minWidth: "20%"
  },
  addButton: {
    // DESIGN.md §9: touch devices get ~44px targets for the primary action.
    [COARSE_POINTER]: {
      minHeight: theme.spacing(5.5),
    },
  },
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: '#fff',
  },
  title: {
    color: theme.palette.primary.darker,
    fontSize: 24,
    fontWeight: 500,
  },
  containerEmpty: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: `${theme.spacing(3)} 0`,
  },
  balanced: {
    color: theme.palette.success.main,
    fontSize: 14,
    fontWeight: 600,
    textAlign: 'end',
    borderColor: 'black',
    borderWidth: 1,
    borderStyle: 'solid',
  },
  underfunded: {
    color: theme.palette.error.main,
    fontSize: 14,
    fontWeight: 600,
    textAlign: 'end',
  },
  disburse: {
    color: theme.palette.warning.dark,
    fontSize: 14,
    fontWeight: 600,
    textAlign: 'end',
  },
  leyendTotals: {
    color: theme.palette.primary.darker,
    fontSize: 14,
    fontWeight: 500,
    textAlign: 'end',
    borderColor: theme.palette.secondary.contrastText,
    borderWidth: 1,
    borderStyle: 'solid',
  },
  allcells: {
    backgroundColor: "#fafafa",
    color: "#607d8b",
    textAlign: "left",
    fontSize: "16px",
    fontWeight: "bold"
  }
}));
